import React from 'react';
import { auth } from './firebase';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoginPanel from './components/LoginPanel';
import AdminPanel from './components/AdminPanel';
import CoordinatorPanel from './components/CoordinatorPanel';
import TeacherPanel from './components/TeacherPanel';
import ParentPanel from './components/ParentPanel';
import InstallPrompt from './components/InstallPrompt';
import WelcomeSplash from './components/WelcomeSplash';
import './App.css';

function Dashboard() {
  const { user, profile, loading, error, role } = useAuth();

  if (!auth) {
    return (
      <div className="mps-app">
        <main className="mps-main">
          <div className="mps-card mps-login-wrap">
            <p className="mps-msg mps-msg-error">
              Firebase is not configured. Copy <code>.env.example</code> to <code>.env.local</code> and restart the app.
            </p>
          </div>
        </main>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="mps-app">
        <main className="mps-main">
          <div className="mps-card">
            <p>Loading…</p>
          </div>
        </main>
      </div>
    );
  }

  if (!user) {
    return <LoginPanel />;
  }

  if (error && !profile) {
    return (
      <div className="mps-app">
        <main className="mps-main">
          <div className="mps-card mps-login-wrap">
            <div className="mps-msg mps-msg-error">{error}</div>
          </div>
        </main>
      </div>
    );
  }

  if (role === 'SUPERUSER') return <AdminPanel />;
  if (role === 'COORDINATOR') return <CoordinatorPanel />;
  if (role === 'TEACHER') return <TeacherPanel />;
  if (role === 'STUDENT' || role === 'PARENT') return <ParentPanel />;
  return <ParentPanel />;
}

function App() {
  return (
    <AuthProvider>
      <WelcomeSplash />
      <InstallPrompt />
      <Dashboard />
    </AuthProvider>
  );
}

export default App;
